import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface ACFChartProps {
  type: 'acf' | 'pacf';
  loading?: boolean;
}

const ACFChart: React.FC<ACFChartProps> = ({ type, loading }) => {
  if (loading) {
    return (
      <div className="h-24 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const acfData = useMemo(() => 
    Array.from({ length: 20 }, (_, i) => ({
      lag: i,
      correlation: Math.exp(-i * 0.1) * Math.cos(i * 0.5) * (Math.random() * 0.5 + 0.5)
    })), []);

  return (
    <div className="w-full h-24 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-2">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={acfData}>
          <CartesianGrid strokeDasharray="2 2" stroke="#e2e8f0" opacity={0.3} />
          <XAxis 
            dataKey="lag" 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 8, fill: '#64748b' }}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 8, fill: '#64748b' }}
          />
          <Tooltip />
          <Bar dataKey="correlation" fill={type === 'acf' ? '#6366f1' : '#10b981'} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ACFChart;